import React from "react";
import { StoreFunctions } from "../context/Store";

export interface AddSelectBlockProps {
  value: string;
  add: StoreFunctions["addLanguage"] | StoreFunctions["addSkill"];
  onChange: StoreFunctions["setTempLanguage"] | StoreFunctions["setTempSkill"];
  placeholder: string;
}

export interface AddSelectBlockState {}

export const AddSelectBlock = (props: AddSelectBlockProps) => {
  const { value, add, onChange, placeholder } = props;
  return (
    <div className="select-block-element add">
      <div className="row">
        <div className="col-12 d-flex align-items-center">
          <div
            className="mark"
            onClick={() => {
              if (value.length >= 3) {
                add();
              }
            }}
          ></div>
          <input
            value={value}
            placeholder={placeholder}
            onChange={(e) => onChange(e.target.value)}
          />
        </div>
      </div>
    </div>
  );
};

export default AddSelectBlock;
